import React from "react";
import PropTypes from "prop-types";
import { Table } from "antd";

const getColumns = (parameter, label) => [
  {
    title: "Hotel ID",
    dataIndex: "hotel_code",
    defaultSortOrder: "descend",
    sorter: (a, b) => a.hotel_code.localeCompare(b.hotel_code),
  },
  {
    title: "Hotel Name",
    dataIndex: "hotel_name",
    sorter: (a, b) => a.hotel_name.localeCompare(b.hotel_name),
  },
  {
    title: label,
    dataIndex: `${parameter}`,
    sorter: (a, b) => (a[parameter] ?? "").localeCompare(b[parameter] ?? ""),
  },
];

const HotelReviewTable = (props) => {
  const { label, parameter, data,rowSelection } = props;
  return data ? (
    <Table
      rowSelection={rowSelection}
      columns={getColumns(parameter, label)}
      dataSource={data??data}
      pagination
      rowKey="_id"
    />
  ) : null;
};

HotelReviewTable.propTypes = {};

export default HotelReviewTable;
